import { get } from "lodash";
import { useMemo } from "react";
import { useQuery } from "react-query";

import { mapPartnerApiToView } from "~/entity/Partners/lib/partnerMapper";
import { IPartner, IPartnerApi } from "~/entity/Partners/model/schema";

import { usePartners } from "./usePartners";

export const useGetPartnerById = (id?: string, enabled = true) => {
  const { queryKeys, getPartnerById } = usePartners();

  const query = useQuery({
    queryKey: queryKeys.byId(id),
    queryFn: () => getPartnerById(id!),
    enabled: !!id && enabled,
  });

  const partnerApi = get(query.data, "data.partner") as IPartnerApi | undefined;
  const partner = useMemo(
    () => (partnerApi ? mapPartnerApiToView(partnerApi) : undefined),
    [partnerApi],
  );

  return {
    ...query,
    partner,
  };
};
